<template>
  <div>
  <Menu></Menu>
    <main>
        <div class=" d-flex w-100 h-100 p-5 mx-auto flex-column ">
        <div class="container">
            <div class="row">

                <br>
        <h1 class="text-q-m text-center"> Preguntas frecuentes</h1>

        <div class="container">
            <div class="row">
              <div class="col-md-12">
                <br>
                <div class="accordion accordion-flush" id="accordionFlushExample">
                  
                  <div class="accordion-item" v-for="(linea,index) in preguntaFrec" :key="index">
                    <h2 class="accordion-header" id="linea">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="`#${linea.Id}`" aria-expanded="false" :aria-controls="linea.Id">
                        <label v-text="linea.NombreParametroValor"></label>
                      </button>
                    </h2>
                    <div :id="linea.Id" class="accordion-collapse collapse" aria-labelledby="linea" data-bs-parent="#accordionFlushExample">
                      <div class="accordion-body" v-text="linea.DetalleParametroValor"></div>
                    </div>
                  </div>
                </div>
              </div>
              <br>
            </div>
        </div> <br>

            </div>
        </div>
        </div>
    </main>
  <footer class=" text-white">
    <div class="container">
        <div class="col-lg-12 footer ">
            <div class="row">
                <div class="col-md-5">
                    <img src="@/assets/img/logo-vertical.png" alt="" width="250">
                     <p>Un servicio de Kallpa Securities S.A.B.</p>
                    <p>RUC: 20492942121</p>
                   
                </div>
                <div class="col-md-4">
                    <h4>Síguenos en:</h4>
                    <a href="https://facebook.com/kallpasablima" target="_blank"><i class="fab fa-facebook-square"></i> @Kallpasablima</a> <br>
                    <a href="https://www.instagram.com/kallpasab/" target="_blank"><i class="fab fa-instagram"></i> @kallpasab</a> <br>
                    <a href="https://twitter.com/KallpaSAB" target="_blank"><i class="fab fa-twitter-square"></i> @KallpaSAB</a> <br>
                    <a href="https://www.linkedin.com/company/kallpa-educa/?viewAsMember=true" target="_blank"><i class="fab fa-linkedin"></i> @KallpaSAB</a>
                </div>
                <div class="col-md-3">
                    <h4 class="cnt">Contáctanos</h4>
                    <ul class="list-footer">
                        <li><i class="fas fa-phone"></i> 630-7500 Anexo 195</li>
                        <li><i class="fas fa-mobile-alt"></i> 940131392</li>
                        <li><i class="fas fa-envelope"></i>clientes@kallpacambios.com</li>
                        <li><i class="fas fa-map-marker-alt"></i>Jr. Monterosa 233 oficina 902,Chacarilla del Estanque, Santiago de Surco.</li>
                        <li>Horario de atención: {{horaInicio}} - {{horaFin}}</li>
                    </ul>
            </div>
            </div>
        </div>
        <hr>
        <div class="col-lg-12 copyright">
            <div class="row d-flex">
                <p class="col-md-8">2021. Kallpa Securities Sociedad Agente de Bolsa // Kallpa Cambios. Todos los derechos reservados. </p>
                <p class="col-md-2"><a :href="urlPoliticasSeguridad" target="_blank" class="poli-term">Políticas de privacidad</a></p>
                <p class="col-md-2"><a :href="urlTerminosCondiciones" target="_blank" class="poli-term">Términos y condiciones</a></p>
            </div>
        </div>
    </div>
</footer>
  </div>
</template>

<script>

import auth from '@/services/auth'
import helpers from '@/services/helpers'

import Menu from "@/layouts/Menu";

import Vue from 'vue';




export default {
  name: "PreguntasFrecuentes",
  
  components: {
    Menu,
  },
  data() {
    return {
      horaInicio:"",
      horaFin:"",
      disabled: true,
      showModal: true,
      preguntaFrec:[],
      urlPoliticasSeguridad:'',
      urlTerminosCondiciones:'',
    };
  },
  beforeCreate() {
    helpers.actualizarTipoCambio(this);
    window.scrollTo(0, 0);
    auth.listParameters().then(response => {
          this.numeroContacto=response.ParametrosGenerales.find(e=>e.Id=="NUKA0001").ValorParametroValor;
          this.horaInicio=response.ParametrosGenerales.find(e=>e.Id=="HOAT0001").ValorParametroValor;
          this.horaFin=response.ParametrosGenerales.find(e=>e.Id=="HOAT0002").ValorParametroValor;
          this.preguntaFrec=response.ParametrosGenerales.filter(e=>e.IdParametro=="PRFR");
          this.urlTerminosCondiciones = response.ParametrosGenerales.find(e=>e.Id == "MENS0006").DetalleParametroValor;
          this.urlPoliticasSeguridad = response.ParametrosGenerales.find(e=>e.Id == "MENS0007").DetalleParametroValor;
    });
    
  },

methods: {


},

mounted() {

  
  },
 
};
</script>





// WEBPACK FOOTER //
// src/components/pages/PreguntasFrecuentes.vue